import { useTranslation } from "react-i18next";

import "modules/PrivacyAndSecurityDashboard/components/PrivacyOverview/PrivacyOverview.scss";

export const PrivacyOverview = () => {
  const { t } = useTranslation();

  return (
    <div className="PrivacyOverview">
      <div className="PrivacyOverview__row">
        {t("v8_in_the_following", "In the following")}&nbsp;
        <a href="https://storage.googleapis.com/claire-dpo-resources/Claire-dataoverview.pdf" rel="noopener noreferrer" target="_blank">
          {t("v8_file", "file")}
        </a>
        &nbsp;
        {t("v8_you_can_read_a_simple_privacy_overview_what_and_how_we_process_data", "you can read a simple privacy overview what and how we process data")}.
      </div>

      <div className="PrivacyOverview__row">
        <a href="https://storage.googleapis.com/claire-dpo-resources/GDPR-intro-website.pdf" rel="noopener noreferrer" target="_blank">
          {t("v8_here", "here")}
        </a>
        &nbsp;
        {t("v8_you_can_read_what_data_we_collect_and_process_from_that_you_deliver_to_us_and_who_has_access_to_it") ||
          "you can read what data we collect and process from that you deliver to us and who has access to it"}
        .
      </div>

      <div className="PrivacyOverview__row">
        {t("v8_Claire_DMSv3_protocol_used_to_pull_data_from_DMS_databases_is_described", "Claire DMSv3 protocol used to pull data from DMS databases is described")}
        &nbsp;
        <a className="link-to-dpo-resource" href="https://storage.googleapis.com/claire-dpo-resources/transparancy_sow.pdf" rel="noopener noreferrer" target="_blank">
          {t("v8_here", "here")}
        </a>
        &nbsp;
        {t("v8_Contact_support_for_more_information", "with the flows and security in places. Contact support for more information")}.
      </div>

      <div className="PrivacyOverview__row">
        {t("v8_The_files_are_guidelines_and_we_will_update_them_if_needed_with_new_information") ||
          "The files are guidelines and we will update them if needed with new information"}
        .
      </div>
    </div>
  );
};
